export const rowsPerPageOptions = [25, 50, 100];
export const labelRowsPerPage = "Строк на странице:";
